import { TypeKeys, WidgetBlockAction } from './types';

type TimerSetAction = WidgetBlockAction<TypeKeys.TIMER_SET_EVENT, { timerId: string }>;

// FIXME: This should be removed. Check with Troy.
const setTimerSet = (widgetId: string, instanceId: string, timerId: string): TimerSetAction => ({
    type: TypeKeys.TIMER_SET_EVENT,
    payload: {
        widgetId,
        instanceId,
        timerId,
    },
});

export default setTimerSet;
export { TimerSetAction };
